import React from 'react';
import styles from '../../styles/interactive-docs.module.css';
import { RotateIcon } from '../../../../components/Icon';

const SandboxWrapper = ({
    title = 'Интерактивный тренажёр рисования',
    badge = null,
    onReset,
    children
}) => {
    return (
        <div className={styles.sandboxWrapper}>
            <div className={styles.sandboxHeader}>
                <div className={styles.sandboxTitleGroup}>
                    {badge && <span className={styles.sandboxTag}>{badge}</span>}
                    <span className={styles.sandboxTitle}>{title}</span>
                </div>
                <div className={styles.sandboxActions}>
                    {onReset && (
                        <button
                            className={styles.sandboxBtn}
                            onClick={onReset}
                            title="Сбросить холст к начальному состоянию"
                        >
                            <RotateIcon size={14} />
                            <span>Сбросить холст</span>
                        </button>
                    )}
                </div>
            </div>
            {children}
        </div>
    );
};

export default SandboxWrapper;
